import { render } from "./FirstSectionImage.vue?vue&type=template&id=d2565eee&scoped=true"
import script from "./FirstSectionImage.vue?vue&type=script&lang=ts"
export * from "./FirstSectionImage.vue?vue&type=script&lang=ts"

import "./FirstSectionImage.vue?vue&type=style&index=0&id=d2565eee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2565eee"

export default script